<template>
  <GcBaseLayout
    :title="report.title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="pageKey"
    :tabs="tabs"
    :selectedIndex="selectedIndex"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Sales Contracts" />
    </template>

    <div class="css-v2 grid-report">
      <gc-data-grid-report
        v-if="report.dataSourceConfig"
        :exportFileName="report.exportFileName"
        :dataSourceConfig="reportDataSourceConfig"
        :columns="columns"
        :persistenceKey="persistenceKey"
        :heightPadding="20"
        :gridToolbar="gridToolbar"
      >
      </gc-data-grid-report>
    </div>
  </GcBaseLayout>
</template>

<script>
import RouteMixin from "@/_mixins/route.mixin";
import ContractListTabsMixin from "@/_mixins/contract-list-tabs.mixin";

import GcDataGridReport from "@/components/gc-data-grid-report";

import { ScreenLayoutService } from "@/_services/api/reports/screen-layout.service";

export default {
  props: {
    /**
     * contains report configurations
     */
    reportConfig: {
      type: Object,
      default: undefined,
    },
  },
  mixins: [RouteMixin, ContractListTabsMixin],
  components: {
    GcDataGridReport,
  },

  data() {
    return {
      persistenceKey: "sales-contract-balance",
      model: {
        Code: "",
        Name: "",
      },
      report: {
        title: "Sales Contracts",
        exportFileName: "",
        featureCode: "",
        dataSourceConfig: null,
        columns: [],
      },
      gridToolbar: {
        search: false,
        columnChooser: true,
        export: true,
        openFilter: true,
        filterOnEnter: true,
      },
    };
  },
  computed: {
    reportDataSourceConfig() {
      var config = this.report.dataSourceConfig;
      // config.filter = [["CustomerCode", "=", this.model.Code]];
      return config;
    },

    columns() {
      var cols = this.report.columns;

      return cols;
    },
  },

  async created() {
    this.selectedIndex = 1;
    let response = await ScreenLayoutService.getByRoute(
      "sales-contract-balance"
    );
    if (response.data.value) {
      this.report = JSON.parse(response.data.value[0].Definition);
    }
  },
  methods: {},
};
</script>
